import {
    updateClassSeries,
    deleteClass,
    deleteClassSeries,
    getClassesByDateRange,
    bookClass,
    cancelClassBooking,
} from './classesRequestConfigs';

class ClassesApi {
    bookClass = bookClass;
    cancelClassBooking = cancelClassBooking;
    deleteClass = deleteClass;
    updateClassSeries = updateClassSeries;
    deleteClassSeries = deleteClassSeries;
    getClassesByDateRange = getClassesByDateRange;
}

class ClassesFactory {
    classes = ClassesApi;
    create() {
        return new this.classes();
    }
}

export const classes = new ClassesFactory();



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/ClassesApi/index.js